import History from 'history'
import * as Menu from '../../components/menu'

export const pageNeedsAuthentication = (history: History.History) => {
  return !history.location.pathname.startsWith(Menu.AUTH_FORGOT_PASSWORD_URL) &&
         !history.location.pathname.startsWith(Menu.AUTH_COGNITO_LOGIN_URL) &&
         !history.location.pathname.startsWith(Menu.AUTH_LOGIN_VALIDATION_URL) &&
         !history.location.pathname.startsWith(Menu.AUTH_LOGIN_URL) &&
         !history.location.pathname.startsWith(Menu.AUTH_FORGOT_PASSWORD_SUCCESS_URL) &&
         !history.location.pathname.startsWith(Menu.AUTH_RESET_PASSWORD_URL) &&
         !history.location.pathname.startsWith(Menu.AUTH_ONBOARD_URL)
}



// WEBPACK FOOTER //
// ./src/pages/auth/utils.ts